import styles from "./QueueModal.module.css"
import { useQueueStore } from '@/stores/useQueueStore';
import { useUserStore } from '@/stores/useUserStore';
import Button, { ButtonKind, ButtonSize } from '@/components/UI/Buttons/Button/Button';
import { useTranslations } from "next-intl";

interface QueueModalProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void
}

export default function QueueModal({ onClose }: QueueModalProps) {
  const { profileId } = useUserStore();
  const { getQueue, getTimer, removeQueue } = useQueueStore();
  const queue = profileId ? getQueue(profileId) : undefined;
  const timer = profileId ? getTimer(profileId) : 0;

  const t = useTranslations("Modals.Queue")

  if(!queue) onClose()
  return (
    queue && <div className={styles.main}>
      <h2>{t('title')}</h2>
      <p>{t.rich('game', {
								game: queue.game.title,
                gameName: (chunks) => (
									<span>{chunks}</span>
								),
							})}</p>
      <p>{t('position')}</p>
      <div className={styles.positionWrapper}>
        <div className={styles.barWrapper}>
            <div className={styles.bar}>
              <div className={styles.position} style={{
                "left": `calc(${(10 - Math.min(queue.position, 10)) * 10}% - 25px)`
              }}><p className="title3">{queue.position}</p></div>
              <div className={styles.barFill} style={{
                "width": `calc(${(10 - Math.min(queue.position, 10)) * 10}% - 2px)`
              }}></div>
              <div className={styles.barVertical} style={{
                "left": `calc(${(10 - Math.min(queue.position, 10)) * 10}% - 2px)`
              }}></div>
            </div>
            <span className="bodyTextMediumStrong">{t('start')}</span>
        </div>
      </div>
      {/* <p>Reintentando en: <b>{timer}s</b></p> */}
      <div className={styles.buttons}>
        <Button kind={ButtonKind.SECONDARY} size={ButtonSize.MEDIUM} onClick={() => removeQueue(queue.profile.id)}>{t('leaveQueue')}</Button>
        <Button kind={ButtonKind.PRIMARY} size={ButtonSize.MEDIUM} onClick={onClose}>{t('ok')}</Button>
      </div>
    </div>
  );
}
